"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiRequireSingleUseToken = exports.ApiRequireSingleUseTokenNoValidation = void 0;
var ApiRequireSingleUseTokenNoValidation;
(function (ApiRequireSingleUseTokenNoValidation) {
    ApiRequireSingleUseTokenNoValidation["registerCashOut"] = "/cashOut/registerCashOut";
})(ApiRequireSingleUseTokenNoValidation || (exports.ApiRequireSingleUseTokenNoValidation = ApiRequireSingleUseTokenNoValidation = {}));
var ApiRequireSingleUseToken;
(function (ApiRequireSingleUseToken) {
    ApiRequireSingleUseToken["balanceTransferCashOut"] = "/balanceTransfer/cashOut";
    ApiRequireSingleUseToken["balanceTransferDraftCashOut"] = "/balanceTransfer/draftCashOut";
    ApiRequireSingleUseToken["balanceTransfer"] = "/balanceTransfer/postBalanceTransfer";
    ApiRequireSingleUseToken["cashToMerchant"] = "/processCashToMerchant";
    ApiRequireSingleUseToken["instantBalanceTransfer"] = "/balanceTransfer/postInstantBalanceTransfer";
    ApiRequireSingleUseToken["acceptInstantBalanceTransferFmpSweep"] = "/balanceTransfer/postAcceptInstantBalanceTransferFmpSweep";
    // *Deprecated May 26, 2023* Keeping enum value since it exists in the db.
    ApiRequireSingleUseToken["balanceTransferCashOutWithBankStatement"] = "/balanceTransfer/cashOutWithBankStatement";
    ApiRequireSingleUseToken["submitGroupedBalanceTransfers"] = "/balanceTransfer/submitGroupedBalanceTransfers";
})(ApiRequireSingleUseToken || (exports.ApiRequireSingleUseToken = ApiRequireSingleUseToken = {}));
